import AnnouncementsPage from "../pages/announcements";
import ViewAnnouncements from "../pages/announcements/view-announcement";
import ProtectedRoute from "./protected";
import React from 'react';

export const AnnouncementsRoutes = [
  <ProtectedRoute exact path='/announcements' component={AnnouncementsPage} />,
  <ProtectedRoute exact path='/announcements/view/:id' component={ViewAnnouncements} />,
]